import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    console.log('dx-tract application started successfully');
  })
  .catch((err) => {
    console.error('Error starting dx-tract application:', err);
  });
